import { InjectionToken } from '@angular/core';

import { IIntercomConfig } from './interfaces/intercom-config.interface';

export const INTERCOM_GONFIG_TOKEN = new InjectionToken<IIntercomConfig>(
  'Intercom Config',
);
